import apiClient from '@/lib/axios';
import type { JobCostOverviewDto } from '../types/jobCostOverview';

export const getJobCostOverview = async (jobId: number): Promise<JobCostOverviewDto> => {
  const response = await apiClient.get<JobCostOverviewDto>(`/jobs/${jobId}/cost-overview`);
  return response.data;
};
